module.exports = __webpack_public_path__ + "img/banner-32.ce53db96.png";